import Step from "./Step";
import { useLocation, useNavigate } from "react-router-dom";

const defaultStepTitles = [
  "WNIOSKODAWCA",
  "EKSPORTOWANY PRODUKT / TOWAR",
  "PROCES PRODUKCJI / ODBIORCA TOWARU",
  "ZAŁĄCZNIKI",
  "PODSUMOWANIE / OŚWIADCZENIA",
];

function Stepper({
  activeStep = 1,
  titles = null,
  warnings = [0, 0, 0, 0, 0],
  messages = [0, 0, 0, 0, 0],
  answeredMessages = [0, 0, 0, 0, 0],
  onclick = null,
  id = null,
  applicationMode = true,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const ownAddress =
    "/" +
    location.pathname.split("/")[1] +
    "/" +
    location.pathname.split("/")[2];
  const idToAppend = id ? "/" + id : "";
  const navigationParams = new URLSearchParams(location.search || "");
  if (applicationMode) {
    navigationParams.set("view", "application");
    navigationParams.delete("focus");
    navigationParams.delete("comment");
    navigationParams.delete("focusRequest");
  }
  const sanitizedSearch = navigationParams.toString();
  const navigationSuffix = `${sanitizedSearch ? `?${sanitizedSearch}` : ""}${location.hash || ""}`;

  let stepActions = [];
  if (applicationMode && id !== "00000000-0000-0000-0000-000000000000")
    stepActions = [
      () =>
        navigate(ownAddress + "/1" + idToAppend + navigationSuffix, {
          replace: true,
        }),
      () =>
        navigate(ownAddress + "/2" + idToAppend + navigationSuffix, {
          replace: true,
        }),
      () =>
        navigate(ownAddress + "/3" + idToAppend + navigationSuffix, {
          replace: true,
        }),
      () =>
        navigate(ownAddress + "/4" + idToAppend + navigationSuffix, {
          replace: true,
        }),
      () =>
        navigate(ownAddress + "/5" + idToAppend + navigationSuffix, {
          replace: true,
        }),
    ];

  const resolvedTitles = titles || defaultStepTitles;

  const stepWarnings = applicationMode
    ? messages.map((openMessages) => openMessages || 0)
    : [0, 0, 0, 0, 0];

  if (onclick) stepActions = onclick;

  /**
   * Określa typ kropki dla danego kroku na podstawie stanu wiadomości
   * @param {number} stepIndex - Indeks kroku (0-4)
   * @returns {string} - Typ kropki: 'danger', 'warning', 'none', lub domyślny
   */
  const getDotType = (stepIndex) => {
    if (!applicationMode) return "default";

    const openMessages = messages[stepIndex] || 0;

    return openMessages > 0 ? "danger" : "none";
  };

  let Steps = resolvedTitles.map(function (title, index) {
    const dotType = getDotType(index);
    const totalCount = stepWarnings[index];

    return (
      <Step
        key={index}
        number={index + 1}
        warning={totalCount}
        title={title}
        active={index === activeStep - 1}
        markCompleted={index + 1 < activeStep && !applicationMode}
        onclick={stepActions[index]}
        applicationMode={applicationMode}
        dotType={dotType}
      />
    );
  });

  return (
    <div className={"ps-4 " + (applicationMode ? "bg-secondary" : "bg-case")}>
      <div className={"d-flex flex-row justify-content-around w55 py-1"}>
        {Steps}
      </div>
    </div>
  );
}

export default Stepper;
